module.exports = __webpack_public_path__ + "static/media/freelectureicon.9180dce4.svg";